import React from 'react';

interface StaticImageWrapperProps {
  description: string;
  imageUrl: string;
  title: string;
}

const StaticImageWrapper = ({ description, imageUrl, title }: StaticImageWrapperProps) => {
  return (
    <figure
      className="relative m-0 p-0 dark:bg-white dark:p-6"
      aria-label={`${title} - ${description}`}
    >
      <img className="block h-auto w-full" src={imageUrl} alt={title} loading="eager" />
    </figure>
  );
};

export default StaticImageWrapper;
